import type { ClassNamesContent } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto, theme } from "@product/scmp-sdk";

export const PopoverCss = (css: ClassNamesContent["css"]) => css`
  position: absolute;
  inset-block-start: 20px;
  inset-inline-end: 0;
  z-index: 1;

  ${theme.breakpoints.up("tablet")} {
    inset-inline-end: 20px;
  }

  & ::part(section-heading) {
    font-size: 12px;
    font-family: ${fontRoboto};
    line-height: 18px;
  }

  & ::part(section-heading-text) {
    color: #6e6e6e;
    font-weight: 700;
    font-size: 12px;
    font-family: ${fontRoboto};
    line-height: 22px;
    text-transform: uppercase;
  }

  & ::part(discrete-panel-signer) {
    color: #444444;
    font-weight: 700;
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 16px;
  }

  & ::part(discrete-panel-date) {
    margin-block-start: 3px;

    font-weight: 300;
    font-size: 15px;
    font-family: ${fontRoboto};
    line-height: 15px;
  }

  & ::part(discrete-panel-container) {
    inline-size: 280px;
    margin-block-start: 50px;
    padding: 20px;
  }

  & ::part(icon-container) {
    position: relative;
    inset-block-end: 5px;
  }
`;

export const Container = styled.div`
  block-size: 350px;

  overflow: auto;

  & ::part(section-layout) {
    gap: 17px;

    padding-block: 20px;
    border-block-end: solid 1px #d8d8d8;
  }
`;

export const SectionData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  font-weight: 300;
  font-size: 13px;
  font-family: ${fontRoboto};
  line-height: 13px;
  a {
    color: #0d66d0 !important;
  }
`;

export const MediaContainer = styled.div`
  display: flex;
  a {
    color: #0d66d0 !important;
    font-size: 13px;
    font-family: ${fontRoboto};
    line-height: 13px;
    text-decoration: underline;
  }

  :not(:first-child) {
    margin-block-start: 3px;
  }
`;

export const ViewMoreButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  padding: 10px;

  color: #ffffff !important;
  font-weight: 700;
  font-size: 15px;
  font-family: ${fontRoboto};
  line-height: 15px;

  border-radius: 20px;

  background-color: #1473e6;

  cursor: pointer;
`;

export const ViewMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-block-start: 20px;
`;
